import React, { useRef, useEffect } from "react";

export default function ChatHeader({
  selectedPhone,
  searchVisible,
  toggleSearch,
  searchQuery,
  setSearchQuery,
  onNext,
  onPrev,
  matchCount = 0,
  currentMatchIndex = 0,
}) {
  const inputRef = useRef(null);

  useEffect(() => {
    if (searchVisible) inputRef.current?.focus();
  }, [searchVisible]);

  return (
    <div className="px-6 py-4 border-b border-gray-200 bg-white shadow-sm">
      <div className="flex items-center gap-3">
        {/* Avatar */}
        <div className="w-10 h-10 bg-gradient-to-br from-blue-400 to-indigo-500 rounded-full flex items-center justify-center text-white font-semibold">
          {selectedPhone ? selectedPhone.slice(-2) : "??"}
        </div>

        {/* User Info */}
        <div className="flex-1">
          <h2 className="font-semibold text-gray-800">{selectedPhone || "Unknown"}</h2>
          <p className="text-xs text-green-600 flex items-center gap-1">
            <span className="w-2 h-2 bg-green-500 rounded-full" />
            Online
          </p>
        </div>

        {/* Search Area */}
        <div className="flex items-center gap-2">
          {searchVisible ? (
            <div className="flex items-center gap-2 bg-gray-100 rounded-lg px-2 py-1">
              <input
                ref={inputRef}
                value={searchQuery}
                onChange={(e) => setSearchQuery(e.target.value)}
                placeholder="Search in chat"
                className="text-sm bg-transparent focus:outline-none w-48"
              />
              <div className="flex items-center gap-1">
                <button onClick={onPrev} title="Previous" className="p-1 text-gray-600 hover:text-gray-800">
                  <svg className="w-4 h-4" viewBox="0 0 20 20" fill="none" stroke="currentColor">
                    <path d="M13 15l-5-5 5-5" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                  </svg>
                </button>
                <button onClick={onNext} title="Next" className="p-1 text-gray-600 hover:text-gray-800">
                  <svg className="w-4 h-4" viewBox="0 0 20 20" fill="none" stroke="currentColor">
                    <path d="M7 5l5 5-5 5" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                  </svg>
                </button>
                <span className="text-xs text-gray-600 px-2">{matchCount > 0 ? `${currentMatchIndex}/${matchCount}` : "0/0"}</span>
                <button onClick={toggleSearch} title="Close" className="p-1 text-gray-400 hover:text-gray-600">
                  ✕
                </button>
              </div>
            </div>
          ) : (
            <button onClick={toggleSearch} className="p-2 text-gray-400 hover:text-gray-600 transition" title="Search in chat">
              <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
              </svg>
            </button>
          )}
        </div>
      </div>
    </div>
  );
}